const React = require('react');
const PropTypes = require('prop-types');

const TrailerSchemaOrg = (props) => {
    const {title, trailer} = props;

    return (
        <span itemScope itemType="http://schema.org/VideoObject">
            <meta itemProp="name" content={title} />
            <meta itemProp="description" content={title} />
            <meta itemProp="thumbnailUrl" content={`https:${trailer.preview.maxSize.src}`} />
            <meta itemProp="uploadDate" content={trailer.date} />
        </span>
    );
};

TrailerSchemaOrg.propTypes = {
    title: PropTypes.string.isRequired,
    trailer: PropTypes.object.isRequired,
};

module.exports = TrailerSchemaOrg;
